import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: easeOut }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ index, kicker, title, italic, className = "" }) => (
  <div className={`mb-16 md:mb-24 ${className}`}>
    <Reveal>
      <div className="flex items-center gap-4 mb-6">
        {index && <span className="font-display text-cyan text-sm tracking-[0.3em]">{index}</span>}
        <span className="h-px w-10 bg-cyan/40" />
        <span className="text-[11px] uppercase tracking-[0.35em] text-[var(--text-2)] font-body">{kicker}</span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight max-w-4xl">
        {title} {italic && <span className="font-serif-italic text-[var(--text-2)]">{italic}</span>}
      </h2>
    </Reveal>
  </div>
);
